<template>
  <div>
    <div v-if="projects && projects.length">
      <div v-for="project in projects" :key="project.id">
        <div class="row align-items-center cursor-pointer my-4" @click.prevent="openProject(project)">
          <div class="col-md-8" v-if="project.picture">
            <img class="img-fluid img-card" :src="project.picture" alt="">
          </div>
          <div class="col-md-4 pr-md-5">
            <h3 class="pt-4">{{ project.name }}</h3>
            <div class="lh15" v-html="project.tagline"></div>
            <div class="py-4">
              <a href="#" @click.prevent="openProject(project)" class="btn btn-sm btn-primary">View Project</a>
            </div>
          </div>
        </div>
        <hr class="space space-sm">
      </div>
    </div>
    <hr class="space space-sm">
    <hr class="py-4">
    <cta></cta>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import CTA from '../Includes/CTA'

export default {
  name: 'dashboard',
  components: {
    'cta': CTA
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      projects: state => state.projects.projects
    })
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('LOAD_PROJECTS')
  },
  methods: {
    openProject (project) {
      this.$router.push({ name: 'project-overview', params: { 'id': project.id } })
    }
  }
}
</script>
